import React from "react";
import { SxStyleProp } from "theme-ui";
import inputStyles from "../../styles/input";
import Box, { Props as BoxProps } from "../Box/Box";

interface Props extends React.HTMLAttributes<HTMLInputElement> {
  sx?: SxStyleProp;
  as?: string;
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void;
  placeholderJSX?: JSX.Element;
}

const Input: React.FunctionComponent<Props & BoxProps> = React.forwardRef(
  ({ sx, type, placeholderJSX, value, ...restProps }, ref) => {
    return (
      <>
        <Box
          ref={ref}
          as="input"
          type={type || "text"}
          variant="input"
          sx={{
            ...inputStyles.base,
            ...(sx as any),
          }}
          value={value}
          {...restProps}
        />
        {!value && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "1rem",
              transform: "translateY(-50%)",
              zIndex: "-1",
              maxWidth: "90%",
            }}
          >
            {placeholderJSX}
          </Box>
        )}
      </>
    );
  },
);

Input.displayName = "Input";

export default Input;
